module.exports = __webpack_public_path__ + "static/media/Facebook.15ad1890.svg";